import ExportDropdownButton, {
  ExportDropdownItem,
} from "components/common/buttons/ExportDropdownButton";
import { Table } from "components/common/forms";
import { DownloadIcon } from "components/icons";
import { useMemo } from "react";
import { Column } from "react-table";
import { Form } from "types/form";
import { getDisplayDate } from "utils/date";

type TablePulseSurveyFeedbackProps = {
  forms: Form[];
  items: ExportDropdownItem[];
  onOpenChange: (id: number) => void;
  isOpen: boolean;
  formId: number;
};

const TablePulseSurveyFeedback: React.FC<TablePulseSurveyFeedbackProps> = ({
  forms,
  items,
  isOpen,
  formId,
  onOpenChange,
}) => {
  const columns: Column<Form>[] = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
        id: "name",
      },
      {
        Header: "Created At",
        accessor: "createdAt",
        id: "createdAt",
        Cell: ({ cell: { value } }) => {
          const dateString = value ? getDisplayDate(value) : "-";
          return <span>{dateString}</span>;
        },
      },
      {
        Header: () => null,
        id: "buttons",
        Cell: ({ row }: { row: { original: Form } }) => (
          <div className="flex items-center justify-end">
            <ExportDropdownButton
              Icon={DownloadIcon}
              id={row.original.id}
              items={items}
              isOpen={row.original.id === formId && isOpen}
              onOpenChange={onOpenChange}
            />
          </div>
        ),
      },
    ],
    [formId, isOpen, items, onOpenChange],
  );

  return <Table columns={columns} data={forms} />;
};

export default TablePulseSurveyFeedback;
